import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("csp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Offline-Robustheit: unbehandelte Netzwerkfehler (z.B. Widget-Fetches während Offline)
// nicht als harte Runtime-Errors durchreichen — die App bleibt offline nutzbar.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const r = event.reason;
    if (r && (r.code === "ERR_NETWORK" || (r.isAxiosError && !r.response))) {
      event.preventDefault();
    }
  });
}

export function formatApiError(detail) {
  if (detail == null) return "Ein Fehler ist aufgetreten.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function openPdf(path) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
}

export async function printPdf(path) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const w = window.open(url, "_blank");
  if (w) {
    const trigger = () => { try { w.focus(); w.print(); } catch (e) { /* noop */ } };
    w.addEventListener("load", trigger);
    setTimeout(trigger, 1200);
  }
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default api;
